import type React from 'react';
import { forwardRef } from 'react';

export interface RulesManagerContentProps {
  children?: React.ReactNode;
}

export const RulesManagerContent = forwardRef<
  HTMLDivElement,
  RulesManagerContentProps
>(({ children }, ref) => {
  return (
    <div
      ref={ref}
      className="flex flex-col flex-grow overflow-auto overflow-x-hidden"
    >
      {children}
    </div>
  );
});
RulesManagerContent.displayName = 'RulesManagerContent';
